import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa'; // Usando ícone da Font Awesome

function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          className="fixed bottom-6 right-6 p-3 rounded-full bg-primary text-white shadow-lg hover:bg-secondary transition-transform transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-primary z-50"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Voltar ao topo"
        >
          <FaArrowUp className="text-xl" />
        </button>
      )}
    </>
  );
}

export default BackToTop;
